module.exports = __webpack_public_path__ + "img/46.73ad3a98.png";